module.exports = __webpack_public_path__ + "static/img/Harrison-Campbell.34c30c6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Harrison-Campbell.jpg
// module id = k2OW
// module chunks = 1